// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.service-card {
  width: calc(100% - 80px);
  height: calc(100dvh - 80px);
  padding: 0 0 80px 80px;
  max-height: 703px;
  position: sticky;
  top: 0;
  border-radius: 64px 64px 0px 0px;
  background-color: #F5F5F5;
  transition: transform 0.1s ease, scale 0.1s ease;
}
@media (min-width: 1620px) {
  .service-card {
    width: calc(100% - 100px);
    height: calc(100dvh - 98px);
    padding: 0 0 98px 100px;
    max-height: 862px;
  }
}
@media (max-width: 1050px) {
  .service-card {
    width: calc(100% - 40px);
    height: 100svh;
    padding: 0 0px 0px 40px;
    max-height: 684px;
  }
}
@media (max-width: 550px) {
  .service-card {
    width: calc(100% - 16px);
    height: calc(100svh - 16px);
    padding: 0 0px 16px 16px;
    max-height: 594px;
    border-radius: 24px 24px 0px 0px;
  }
}
.service-card:last-child:after {
  content: "";
  width: 100%;
  height: 20px;
  position: absolute;
  background-color: #982D67;
  bottom: -20px;
  left: 0;
}
.service-card .service-card-container {
  width: 100%;
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
  border-radius: 0px 64px 0px 0px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}
@media (max-width: 1050px) {
  .service-card .service-card-container {
    width: calc(100% - 40px);
    padding-right: 40px;
  }
}
@media (max-width: 550px) {
  .service-card .service-card-container {
    width: calc(100% - 16px);
    padding-right: 16px;
    border-radius: 0px 24px 0px 0px;
  }
}
.service-card .service-card-container .sercvice-card-lottie-container {
  width: 1000px;
  height: 500px;
  position: absolute;
  top: -15%;
  right: -30%;
  transform: scaleX(-1);
  scale: 4.5;
}
@media (min-width: 1620px) {
  .service-card .service-card-container .sercvice-card-lottie-container {
    scale: 5.5;
    top: -8%;
    right: -22%;
  }
}
@media (max-width: 1050px) {
  .service-card .service-card-container .sercvice-card-lottie-container {
    scale: 3.5;
    top: -25%;
    right: -38%;
  }
}
@media (max-width: 900px) {
  .service-card .service-card-container .sercvice-card-lottie-container {
    scale: 3;
    top: -25%;
    right: -50%;
  }
}
@media (max-width: 750px) {
  .service-card .service-card-container .sercvice-card-lottie-container {
    right: -60%;
  }
}
@media (max-width: 700px) {
  .service-card .service-card-container .sercvice-card-lottie-container {
    scale: 2.5;
    right: -70%;
    top: -27%;
  }
}
@media (max-width: 700px) {
  .service-card .service-card-container .sercvice-card-lottie-container {
    right: -80%;
    scale: 1.5;
  }
}
@media (max-width: 600px) {
  .service-card .service-card-container .sercvice-card-lottie-container {
    right: -90%;
  }
}
@media (max-width: 550px) {
  .service-card .service-card-container .sercvice-card-lottie-container {
    top: -32%;
    right: -100%;
  }
}
@media (max-width: 460px) {
  .service-card .service-card-container .sercvice-card-lottie-container {
    right: -110%;
  }
}
@media (max-width: 420px) {
  .service-card .service-card-container .sercvice-card-lottie-container {
    right: -120%;
  }
}
@media (max-width: 385px) {
  .service-card .service-card-container .sercvice-card-lottie-container {
    right: -140%;
  }
}
.service-card .service-card-container .service-card-title-box {
  width: 100%;
  padding: 88px 0 48px 0;
  border-bottom: 3px solid #EAEAEA;
  gap: 64px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
@media (min-width: 1620px) {
  .service-card .service-card-container .service-card-title-box {
    padding: 96px 0 64px 0;
  }
}
@media (max-width: 1050px) {
  .service-card .service-card-container .service-card-title-box {
    padding: 54px 0 38px 0;
  }
}
@media (max-width: 750px) {
  .service-card .service-card-container .service-card-title-box {
    gap: 32px;
  }
}
@media (max-width: 550px) {
  .service-card .service-card-container .service-card-title-box {
    gap: 12px;
    padding: 32px 0 32px 0;
  }
}
.service-card .service-card-container .service-card-title-box ul {
  height: 87px;
  color: #E0E0E0;
  text-transform: uppercase;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  font-family: FixelDisplay;
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
}
@media (min-width: 1620px) {
  .service-card .service-card-container .service-card-title-box ul {
    height: 117px;
    font-family: FixelDisplay;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 100%;
  }
}
@media (max-width: 1050px) {
  .service-card .service-card-container .service-card-title-box ul {
    height: 72px;
    font-family: FixelDisplay;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: 100%;
  }
}
@media (max-width: 550px) {
  .service-card .service-card-container .service-card-title-box ul {
    color: rgba(126, 126, 126, 0.3254901961);
    height: 34px;
    font-family: FixelDisplay;
    font-size: 6px;
    font-style: normal;
    font-weight: 600;
    line-height: 100%;
  }
}
.service-card .service-card-container .service-card-title-box ul li.protect {
  color: #9292EA;
}
.service-card .service-card-container .service-card-title-box ul li.detect {
  color: #FAB746;
}
.service-card .service-card-container .service-card-title-box ul li.respond {
  color: #F97367;
}
.service-card .service-card-container .service-card-title-box ul li.recover {
  color: #7DF4A0;
}
.service-card .service-card-container .service-card-title-box ul li.govern {
  color: #FAF49E;
}
.service-card .service-card-container .service-card-title-box ul li.identify {
  color: #4BB2DF;
}
.service-card .service-card-container .service-card-title-box h2 {
  color: #575756;
  letter-spacing: -4.96px;
  text-transform: uppercase;
  font-family: FixelDisplay;
  font-size: 124px;
  font-style: normal;
  font-weight: 400;
  line-height: 90%;
}
@media (min-width: 1620px) {
  .service-card .service-card-container .service-card-title-box h2 {
    height: 110px;
    font-family: FixelDisplay;
    font-size: 160px;
    font-style: normal;
    font-weight: 400;
    line-height: 90%;
  }
}
@media (max-width: 1050px) {
  .service-card .service-card-container .service-card-title-box h2 {
    height: 45px;
    letter-spacing: -1.92px;
    font-family: FixelDisplay;
    font-size: 64px;
    font-style: normal;
    font-weight: 400;
    line-height: 90%;
  }
}
@media (max-width: 550px) {
  .service-card .service-card-container .service-card-title-box h2 {
    height: 32px;
    letter-spacing: -1.38px;
    font-family: FixelDisplay;
    font-size: 46px;
    font-style: normal;
    font-weight: 400;
    line-height: 90%;
  }
}
.service-card .service-card-container .service-card-info-box {
  position: absolute;
  bottom: 0;
  left: 99%;
  transition: left 0.1s ease;
}
@media (max-width: 1050px) {
  .service-card .service-card-container .service-card-info-box {
    width: calc(100% - 40px);
    height: 436px;
    left: 0;
    bottom: 40px;
    overflow: visible;
  }
}
@media (max-width: 750px) {
  .service-card .service-card-container .service-card-info-box {
    height: 348px;
  }
}
@media (max-width: 550px) {
  .service-card .service-card-container .service-card-info-box {
    width: calc(100% - 16px);
    height: 384px;
  }
}
.service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper {
  position: relative;
  width: max-content;
  height: 406px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
}
@media (min-width: 1620px) {
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper {
    height: 498px;
  }
}
@media (max-width: 1050px) {
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper {
    width: 100%;
    height: 2px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
}
.service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item {
  width: 604px;
  height: 304px;
  padding: 48px;
  background-color: #FFFFFF;
  border-radius: 32px;
  border: 3px solid #EAEAEA;
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
}
@media (min-width: 1050px) {
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(1) {
    left: 0px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(2) {
    left: 686px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(3) {
    left: 1372px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(4) {
    left: 2058px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(5) {
    left: 2744px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(6) {
    left: 3430px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(7) {
    left: 4116px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(8) {
    left: 4802px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(9) {
    left: 5488px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(10) {
    left: 6174px;
  }
}
@media (min-width: 1620px) {
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item {
    width: 740px;
    height: 364px;
    padding: 64px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(1) {
    left: 0px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(2) {
    left: 854px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(3) {
    left: 1708px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(4) {
    left: 2562px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(5) {
    left: 3416px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(6) {
    left: 4270px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(7) {
    left: 5124px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(8) {
    left: 5978px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(9) {
    left: 6832px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(10) {
    left: 7686px;
  }
}
@media (max-width: 1050px) {
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item {
    width: calc(100% - 102px);
    height: 294px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(1) {
    top: 0px;
    left: 0px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(2) {
    top: 387px;
    left: 0px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(3) {
    top: 774px;
    left: 0px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(4) {
    top: 1161px;
    left: 0px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(5) {
    top: 1548px;
    left: 0px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(6) {
    top: 1935px;
    left: 0px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(7) {
    top: 2322px;
    left: 0px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(8) {
    top: 2709px;
    left: 0px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(9) {
    top: 3096px;
    left: 0px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(10) {
    top: 3483px;
    left: 0px;
  }
}
@media (max-width: 750px) {
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item {
    padding: 24px;
    width: calc(100% - 54px);
    height: 294px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(1) {
    top: 0px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(2) {
    top: 333px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(3) {
    top: 666px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(4) {
    top: 999px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(5) {
    top: 1332px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(6) {
    top: 1665px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(7) {
    top: 1998px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(8) {
    top: 2331px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(9) {
    top: 2664px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(10) {
    top: 2997px;
  }
}
@media (max-width: 550px) {
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item {
    height: 330px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(1) {
    top: 0px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(2) {
    top: 369px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(3) {
    top: 738px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(4) {
    top: 1107px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(5) {
    top: 1476px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(6) {
    top: 1845px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(7) {
    top: 2214px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(8) {
    top: 2583px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(9) {
    top: 2952px;
  }
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item:nth-child(10) {
    top: 3321px;
  }
}
.service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item p {
  width: 364px;
  color: #313130;
  font-family: FixelText;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
}
@media (min-width: 1620px) {
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item p {
    width: 434px;
    font-family: FixelText;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
  }
}
@media (max-width: 1050px) {
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item p {
    width: 410px;
    font-family: FixelText;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
  }
}
@media (max-width: 750px) {
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item p {
    display: none;
  }
}
.service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item div {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}
@media (max-width: 750px) {
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item div {
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
}
.service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item div span {
  width: 200px;
  color: #575756;
  text-transform: uppercase;
  font-family: FixelDisplay;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
}
@media (min-width: 1620px) {
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item div span {
    width: 258px;
    font-family: FixelDisplay;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: 100%;
  }
}
@media (max-width: 1050px) {
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item div span {
    width: 200px;
    font-family: FixelText;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 100%;
  }
}
@media (max-width: 750px) {
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item div span {
    width: 100%;
    margin-bottom: 24px;
  }
}
@media (max-width: 750px) {
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item div span {
    font-family: FixelText;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 120%;
  }
}
.service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item div .service-card-info-box-text-mobile {
  display: none;
}
@media (max-width: 750px) {
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item div .service-card-info-box-text-mobile {
    width: 100%;
    display: block;
    font-family: FixelText;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
  }
}
.service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item div img {
  animation: rotatingStar 8s linear infinite;
}
@media (max-width: 750px) {
  .service-card .service-card-container .service-card-info-box .service-card-info-box-inner-wrapper .service-card-info-item div img {
    visibility: hidden;
    position: absolute;
    bottom: 0;
    left: 0;
  }
}

@keyframes rotatingStar {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ServicesSection/ServiceCard/ServiceCard.scss","webpack://./src/styles/variables.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AAGA;EACI,wBAAA;EACA,2BAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,MAAA;EACA,gCAAA;EACA,yBCPe;EDQf,gDAAA;AAFJ;AAII;EAXJ;IAYQ,yBAAA;IACA,2BAAA;IACA,uBAAA;IACA,iBAAA;EADN;AACF;AAGI;EAlBJ;IAmBQ,wBAAA;IACA,cAAA;IACA,uBAAA;IACA,iBAAA;EAAN;AACF;AAEI;EAzBJ;IA0BQ,wBAAA;IACA,2BAAA;IACA,wBAAA;IACA,iBAAA;IACA,gCAAA;EACN;AACF;AAEQ;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBCxCC;EDyCD,aAAA;EACA,OAAA;AAAZ;AAII;EACI,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,+BAAA;EErDJ,aAAA;EACA,sBFqDyB;EEpDzB,8BFoDiC;EEnDjC,uBFmDgD;AACpD;AACQ;EATJ;IAUQ,wBAAA;IACA,mBAAA;EAEV;AACF;AAAQ;EAdJ;IAeQ,wBAAA;IACA,mBAAA;IACA,+BAAA;EAGV;AACF;AADQ;EACI,aAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,qBAAA;EACA,UAAA;AAGZ;AADY;EATJ;IAUQ,UAAA;IACA,QAAA;IACA,WAAA;EAId;AACF;AAFY;EAfJ;IAgBQ,UAAA;IACA,SAAA;IACA,WAAA;EAKd;AACF;AAHY;EArBJ;IAsBQ,QAAA;IACA,SAAA;IACA,WAAA;EAMd;AACF;AAJY;EA3BJ;IA4BQ,WAAA;EAOd;AACF;AALY;EA/BJ;IAgCQ,UAAA;IACA,WAAA;IACA,SAAA;EAQd;AACF;AANY;EArCJ;IAsCQ,WAAA;IACA,UAAA;EASd;AACF;AAPY;EA1CJ;IA2CQ,WAAA;EAUd;AACF;AARY;EA9CJ;IA+CQ,SAAA;IACA,YAAA;EAWd;AACF;AATY;EAnDJ;IAoDQ,YAAA;EAYd;AACF;AAVY;EAvDJ;IAwDQ,YAAA;EAad;AACF;AAXY;EA3DJ;IA4DQ,YAAA;EAcd;AACF;AAXQ;EACI,WAAA;EACA,sBAAA;EACA,gCAAA;EACA,SAAA;EEvIR,aAAA;EACA,mBFuI6B;EEtI7B,2BFsIkC;EErIlC,mBFqI8C;AAgBlD;AAdY;EAPJ;IAQQ,sBAAA;EAiBd;AACF;AAfY;EAXJ;IAYQ,sBAAA;EAkBd;AACF;AAhBY;EAfJ;IAgBQ,SAAA;EAmBd;AACF;AAjBY;EAnBJ;IAoBQ,SAAA;IACA,sBAAA;EAoBd;AACF;AAlBY;EACI,YAAA;EACA,cCvJF;EDwJE,yBAAA;EE9JZ,aAAA;EACA,sBF8JiC;EE7JjC,8BF6JyC;EE5JzC,uBF4JwD;EExJxD,yBFyJiC;EExJjC,eFwJ+C;EEvJ/C,kBFuJqD;EEtJrD,gBFsJ6D;EErJ7D,iBFqJkE;AA2BtE;AAzBgB;EAPJ;IAQQ,aAAA;IE5JhB,yBF6JqC;IE5JrC,eF4JmD;IE3JnD,kBF2JyD;IE1JzD,gBF0JiE;IEzJjE,iBFyJsE;EAgCxE;AACF;AA9BgB;EAZJ;IAaQ,YAAA;IEjKhB,yBFkKqC;IEjKrC,eFiKmD;IEhKnD,kBFgKyD;IE/JzD,gBF+JiE;IE9JjE,iBF8JsE;EAqCxE;AACF;AAnCgB;EAjBJ;IAkBQ,wCAAA;IACA,YAAA;IEvKhB,yBFwKqC;IEvKrC,cFuKmD;IEtKnD,kBFsKwD;IErKxD,gBFqKgE;IEpKhE,iBFoKqE;EA0CvE;AACF;AAvCoB;EACI,cAAA;AAyCxB;AAtCoB;EACI,cAAA;AAwCxB;AArCoB;EACI,cAAA;AAuCxB;AApCoB;EACI,cAAA;AAsCxB;AAnCoB;EACI,cAAA;AAqCxB;AAlCoB;EACI,cAAA;AAoCxB;AA/BY;EACI,cCvMJ;EDwMI,uBAAA;EACA,yBAAA;EEzMZ,yBF0MiC;EEzMjC,gBFyM+C;EExM/C,kBFwMsD;EEvMtD,gBFuM8D;EEtM9D,gBFsMmE;AAqCvE;AAnCgB;EANJ;IAOQ,aAAA;IE7MhB,yBF8MqC;IE7MrC,gBF6MmD;IE5MnD,kBF4M0D;IE3M1D,gBF2MkE;IE1MlE,gBF0MuE;EA0CzE;AACF;AAxCgB;EAXJ;IAYQ,YAAA;IACA,uBAAA;IEnNhB,yBFoNqC;IEnNrC,eFmNmD;IElNnD,kBFkNyD;IEjNzD,gBFiNiE;IEhNjE,gBFgNsE;EA+CxE;AACF;AA7CgB;EAjBJ;IAkBQ,YAAA;IACA,uBAAA;IEzNhB,yBF0NqC;IEzNrC,eFyNmD;IExNnD,kBFwNyD;IEvNzD,gBFuNiE;IEtNjE,gBFsNsE;EAoDxE;AACF;AAhDQ;EACI,kBAAA;EACA,SAAA;EACA,SAAA;EACA,0BAAA;AAkDZ;AAhDY;EANJ;IAOQ,wBAAA;IACA,aAAA;IACA,OAAA;IACA,YAAA;IACA,iBAAA;EAmDd;AACF;AAjDY;EAdJ;IAeQ,aAAA;EAoDd;AACF;AAlDY;EAlBJ;IAmBQ,wBAAA;IACA,aAAA;EAqDd;AACF;AAnDY;EACI,kBAAA;EACA,kBAAA;EACA,aAAA;EEhQZ,aAAA;EACA,mBFgQiC;EE/PjC,2BF+PsC;EE9PtC,uBF8PkD;AAwDtD;AAtDgB;EANJ;IAOQ,aAAA;EAyDlB;AACF;AAvDgB;EAVJ;IAWQ,WAAA;IACA,WAAA;IEzQhB,aAAA;IACA,sBFyQqC;IExQrC,2BFwQ6C;IEvQ7C,uBFuQyD;EA6D3D;AACF;AA3DgB;EACI,YAAA;EACA,aAAA;EACA,aAAA;EACA,yBC/QZ;EDgRY,mBAAA;EACA,yBAAA;EAEA,kBAAA;EACA,MAAA;EEtRhB,aAAA;EACA,mBFuRqC;EEtRrC,8BFsR0C;EErR1C,uBFqRyD;AA8D7D;AA5DoB;EAEQ;IACI,SAAA;EA6D9B;EA9D0B;IACI,WAAA;EAgE9B;EAjE0B;IACI,YAAA;EAmE9B;EApE0B;IACI,YAAA;EAsE9B;EAvE0B;IACI,YAAA;EAyE9B;EA1E0B;IACI,YAAA;EA4E9B;EA7E0B;IACI,YAAA;EA+E9B;EAhF0B;IACI,YAAA;EAkF9B;EAnF0B;IACI,YAAA;EAqF9B;EAtF0B;IACI,YAAA;EAwF9B;AACF;AAnFoB;EAtBJ;IAuBQ,YAAA;IACA,aAAA;IACA,aAAA;EAsFtB;EApF0B;IACI,SAAA;EAsF9B;EAvF0B;IACI,WAAA;EAyF9B;EA1F0B;IACI,YAAA;EA4F9B;EA7F0B;IACI,YAAA;EA+F9B;EAhG0B;IACI,YAAA;EAkG9B;EAnG0B;IACI,YAAA;EAqG9B;EAtG0B;IACI,YAAA;EAwG9B;EAzG0B;IACI,YAAA;EA2G9B;EA5G0B;IACI,YAAA;EA8G9B;EA/G0B;IACI,YAAA;EAiH9B;AACF;AA5GoB;EAlCJ;IAmCQ,yBAAA;IACA,aAAA;EA+GtB;EA7G0B;IACI,QAAA;IACA,SAAA;EA+G9B;EAjH0B;IACI,UAAA;IACA,SAAA;EAmH9B;EArH0B;IACI,UAAA;IACA,SAAA;EAuH9B;EAzH0B;IACI,WAAA;IACA,SAAA;EA2H9B;EA7H0B;IACI,WAAA;IACA,SAAA;EA+H9B;EAjI0B;IACI,WAAA;IACA,SAAA;EAmI9B;EArI0B;IACI,WAAA;IACA,SAAA;EAuI9B;EAzI0B;IACI,WAAA;IACA,SAAA;EA2I9B;EA7I0B;IACI,WAAA;IACA,SAAA;EA+I9B;EAjJ0B;IACI,WAAA;IACA,SAAA;EAmJ9B;AACF;AA/IoB;EA7CJ;IA8CQ,aAAA;IACA,wBAAA;IACA,aAAA;EAkJtB;EAhJ0B;IACI,QAAA;EAkJ9B;EAnJ0B;IACI,UAAA;EAqJ9B;EAtJ0B;IACI,UAAA;EAwJ9B;EAzJ0B;IACI,UAAA;EA2J9B;EA5J0B;IACI,WAAA;EA8J9B;EA/J0B;IACI,WAAA;EAiK9B;EAlK0B;IACI,WAAA;EAoK9B;EArK0B;IACI,WAAA;EAuK9B;EAxK0B;IACI,WAAA;EA0K9B;EA3K0B;IACI,WAAA;EA6K9B;AACF;AAzKoB;EAxDJ;IAyDQ,aAAA;EA4KtB;EA1K0B;IACI,QAAA;EA4K9B;EA7K0B;IACI,UAAA;EA+K9B;EAhL0B;IACI,UAAA;EAkL9B;EAnL0B;IACI,WAAA;EAqL9B;EAtL0B;IACI,WAAA;EAwL9B;EAzL0B;IACI,WAAA;EA2L9B;EA5L0B;IACI,WAAA;EA8L9B;EA/L0B;IACI,WAAA;EAiM9B;EAlM0B;IACI,WAAA;EAoM9B;EArM0B;IACI,WAAA;EAuM9B;AACF;AAnMoB;EACI,YAAA;EACA,cCvUjB;ECFH,sBF0UyC;EEzUzC,eFyUoD;EExUpD,kBFwU0D;EEvU1D,gBFuUkE;EEtUlE,iBFsUuE;AAyM3E;AAvMwB;EALJ;IAMQ,YAAA;IE7UxB,sBF8U6C;IE7U7C,eF6UwD;IE5UxD,kBF4U8D;IE3U9D,gBF2UsE;IE1UtE,iBF0U2E;EA8M7E;AACF;AA5MwB;EAVJ;IAWQ,YAAA;IElVxB,sBFmV6C;IElV7C,eFkVwD;IEjVxD,kBFiV8D;IEhV9D,gBFgVsE;IE/UtE,iBF+U2E;EAmN7E;AACF;AAjNwB;EAfJ;IAgBQ,aAAA;EAoN1B;AACF;AAjNoB;EACI,YAAA;EEnWpB,aAAA;EACA,sBFmWyC;EElWzC,8BFkWiD;EEjWjD,uBFiWgE;AAsNpE;AApNwB;EAJJ;IAKQ,WAAA;IACA,kBAAA;IExWxB,aAAA;IACA,sBFwW6C;IEvW7C,2BFuWqD;IEtWrD,uBFsWiE;EA0NnE;AACF;AAxNwB;EACI,YAAA;EACA,cCvWhB;EDwWgB,yBAAA;EExWxB,yBFyW6C;EExW7C,eFwW2D;EEvW3D,kBFuWiE;EEtWjE,gBFsWyE;EErWzE,iBFqW8E;AA8NlF;AA5N4B;EANJ;IAOQ,YAAA;IE5W5B,yBF6WiD;IE5WjD,eF4W+D;IE3W/D,kBF2WqE;IE1WrE,gBF0W6E;IEzW7E,iBFyWkF;EAmOpF;AACF;AAjO4B;EAXJ;IAYQ,YAAA;IEjX5B,sBFkXiD;IEjXjD,eFiX4D;IEhX5D,kBFgXkE;IE/WlE,gBF+W0E;IE9W1E,iBF8W+E;EAwOjF;AACF;AAtO4B;EAhBJ;IAiBQ,WAAA;IACA,mBAAA;EAyO9B;AACF;AAvO4B;EArBJ;IErWpB,sBF2XiD;IE1XjD,eF0X4D;IEzX5D,kBFyXkE;IExXlE,gBFwX0E;IEvX1E,iBFuX+E;EA8OjF;AACF;AA3OwB;EACI,aAAA;AA6O5B;AA3O4B;EAHJ;IAIQ,WAAA;IACA,cAAA;IEpY5B,sBFqYiD;IEpYjD,eFoY4D;IEnY5D,kBFmYkE;IElYlE,gBFkY0E;IEjY1E,iBFiY+E;EAkPjF;AACF;AA/OwB;EACI,0CAAA;AAiP5B;AA/O4B;EAHJ;IAIQ,kBAAA;IACA,kBAAA;IACA,SAAA;IACA,OAAA;EAkP9B;AACF;;AAvOA;EACI;IACE,uBAAA;EA0OJ;EAxOE;IACE,yBAAA;EA0OJ;AACF","sourcesContent":["@use '../../../styles/mixins.scss';\n@import '../../../styles/variables.scss';\n\n.service-card {\n    width: calc(100% - 80px);\n    height: calc(100dvh - 80px);\n    padding: 0 0 80px 80px;\n    max-height: 703px;\n    position: sticky;\n    top: 0;\n    border-radius: 64px 64px 0px 0px;\n    background-color: $light-background;\n    transition: transform 0.1s ease, scale 0.1s ease;\n\n    @media (min-width: 1620px) {\n        width: calc(100% - 100px);\n        height: calc(100dvh - 98px);\n        padding: 0 0 98px 100px;\n        max-height: 862px;\n    }\n\n    @media (max-width: 1050px) {\n        width: calc(100% - 40px);\n        height: calc(100svh);\n        padding: 0 0px 0px 40px;\n        max-height: 684px;\n    }\n\n    @media (max-width: 550px) {\n        width: calc(100% - 16px);\n        height: calc(100svh - 16px);\n        padding: 0 0px 16px 16px;\n        max-height: 594px;\n        border-radius: 24px 24px 0px 0px;\n    }\n\n    &:last-child {\n        &:after {\n            content: '';\n            width: calc(100%);\n            height: 20px;\n            position: absolute;\n            background-color: $main-color;\n            bottom: -20px;\n            left: 0;\n        }\n    }\n\n    .service-card-container {\n        width: 100%;\n        height: 100%;\n        width: 100%;\n        position: relative;\n        overflow: hidden;\n        border-radius: 0px 64px 0px 0px;\n        @include mixins.flex(column, space-between, flex-start);\n\n        @media (max-width: 1050px) {\n            width: calc(100% - 40px);\n            padding-right: 40px;\n        }\n\n        @media (max-width: 550px) {\n            width: calc(100% - 16px);\n            padding-right: 16px;\n            border-radius: 0px 24px 0px 0px;\n        }\n\n        .sercvice-card-lottie-container {\n            width: 1000px;\n            height: 500px;\n            position: absolute;\n            top: -15%;\n            right: -30%;\n            transform: scaleX(-1);\n            scale: 4.5;\n\n            @media (min-width: 1620px) {\n                scale: 5.5;\n                top: -8%;\n                right: -22%;\n            }\n\n            @media (max-width: 1050px) {\n                scale: 3.5;\n                top: -25%;\n                right: -38%;\n            }\n\n            @media (max-width: 900px) {\n                scale: 3;\n                top: -25%;\n                right: -50%;\n            }\n\n            @media (max-width: 750px) {\n                right: -60%;\n            }\n\n            @media (max-width: 700px) {\n                scale: 2.5;\n                right: -70%;\n                top: -27%;\n            }\n\n            @media (max-width: 700px) {\n                right: -80%;\n                scale: 1.5;\n            }\n\n            @media (max-width: 600px) {\n                right: -90%;\n            }\n\n            @media (max-width: 550px) {\n                top: -32%;\n                right: -100%;\n            }\n\n            @media (max-width: 460px) {\n                right: -110%;\n            }\n\n            @media (max-width: 420px) {\n                right: -120%;\n            }\n\n            @media (max-width: 385px) {\n                right: -140%;\n            }\n        }\n\n        .service-card-title-box {\n            width: 100%;\n            padding: 88px 0 48px 0;\n            border-bottom: 3px solid $grey;\n            gap: 64px;\n            @include mixins.flex(row, flex-start, center);\n\n            @media (min-width: 1620px) {\n                padding: 96px 0 64px 0;\n            }\n\n            @media (max-width: 1050px) {\n                padding: 54px 0 38px 0;\n            }\n\n            @media (max-width: 750px) {\n                gap: 32px;\n            }\n\n            @media (max-width: 550px) {\n                gap: 12px;\n                padding: 32px 0 32px 0;\n            }\n\n            ul {\n                height: 87px;\n                color: $grey-opacity;\n                text-transform: uppercase;\n                @include mixins.flex(column, space-between, flex-start);\n                @include mixins.font(FixelDisplay, 10px, normal, 600, 100%);\n\n                @media (min-width: 1620px) {\n                    height: 117px;\n                    @include mixins.font(FixelDisplay, 14px, normal, 600, 100%);\n                }\n\n                @media (max-width: 1050px) {\n                    height: 72px;\n                    @include mixins.font(FixelDisplay, 10px, normal, 600, 100%);\n                }\n\n                @media (max-width: 550px) {\n                    color: #7e7e7e53;\n                    height: 34px;\n                    @include mixins.font(FixelDisplay, 6px, normal, 600, 100%);\n                }\n\n                li {\n                    &.protect {\n                        color: #9292EA;                    \n                    }\n\n                    &.detect {\n                        color: #FAB746;                    \n                    }\n\n                    &.respond {\n                        color: #F97367;\n                    }\n\n                    &.recover {\n                        color: #7DF4A0;\n                    }\n\n                    &.govern {\n                        color: #FAF49E;\n                    }\n\n                    &.identify {\n                        color: #4BB2DF;\n                    }\n                }\n            }\n\n            h2 {\n                color: $grey-dark;\n                letter-spacing: -4.96px;\n                text-transform: uppercase;\n                @include mixins.font(FixelDisplay, 124px, normal, 400, 90%);\n\n                @media (min-width: 1620px) {\n                    height: 110px;\n                    @include mixins.font(FixelDisplay, 160px, normal, 400, 90%);\n                }\n\n                @media (max-width: 1050px) {\n                    height: 45px;\n                    letter-spacing: -1.92px;\n                    @include mixins.font(FixelDisplay, 64px, normal, 400, 90%);\n                }\n\n                @media (max-width: 550px) {\n                    height: 32px;\n                    letter-spacing: -1.38px;\n                    @include mixins.font(FixelDisplay, 46px, normal, 400, 90%);\n                }\n            }\n        }\n\n        .service-card-info-box {\n            position: absolute;\n            bottom: 0;\n            left: 99%;\n            transition: left 0.1s ease;\n\n            @media (max-width: 1050px) {\n                width: calc(100% - 40px);\n                height: 436px;\n                left: 0;\n                bottom: 40px;\n                overflow: visible;\n            }\n\n            @media (max-width: 750px) {\n                height: 348px;\n            }\n\n            @media (max-width: 550px) {\n                width: calc(100% - 16px);\n                height: 384px;\n            }\n\n            .service-card-info-box-inner-wrapper {\n                position: relative;\n                width: max-content;\n                height: 406px;\n                @include mixins.flex(row, flex-start, flex-start);\n\n                @media (min-width: 1620px) {\n                    height: 498px;\n                }\n\n                @media (max-width: 1050px) {\n                    width: 100%;\n                    height: 2px;\n                    @include mixins.flex(column, flex-start, flex-start);\n                }\n\n                .service-card-info-item {\n                    width: 604px;\n                    height: 304px;\n                    padding: 48px;\n                    background-color: $white;\n                    border-radius: 32px;\n                    border: 3px solid $grey;\n                    // transition: left 0.1s ease;\n                    position: absolute;\n                    top: 0;\n                    // left: 0;\n                    @include mixins.flex(row, space-between, flex-start);\n\n                    @media (min-width: 1050px) {  \n                        @for $i from 1 through 10 {\n                            &:nth-child(#{$i}) {\n                                left: #{(($i - 1) * 706) - (($i - 1) * 20)}px;\n                                // margin-left: -#{($i - 1) * 20}px;\n                            }\n                        }\n                    }\n\n                    @media (min-width: 1620px) {\n                        width: 740px;\n                        height: 364px;\n                        padding: 64px;\n                        @for $i from 1 through 10 {\n                            &:nth-child(#{$i}) {\n                                left: #{(($i - 1) * 874) - (($i - 1) * 20)}px;\n                                // margin-left: -#{($i - 1) * 20}px;\n                            }\n                        }\n                    }\n\n                    @media (max-width: 1050px) {\n                        width: calc(100% - 102px);\n                        height: 294px;\n                        @for $i from 1 through 10 {\n                            &:nth-child(#{$i}) {\n                                top: #{(($i - 1) * 402) - (($i - 1) * 15)}px;\n                                left: #{(($i - 1) * 0) - (($i - 1) * 0)}px;\n                            }\n                        }\n                    }\n\n                    @media (max-width: 750px) {\n                        padding: 24px;\n                        width: calc(100% - 54px);\n                        height: 294px;\n                        @for $i from 1 through 10 {\n                            &:nth-child(#{$i}) {\n                                top: #{(($i - 1) * 348) - (($i - 1) * 15)}px;\n                            }\n                        }\n                    }\n\n                    @media (max-width: 550px) {\n                        height: 330px;\n                        @for $i from 1 through 10 {\n                            &:nth-child(#{$i}) {\n                                top: #{(($i - 1) * 384) - (($i - 1) * 15)}px;\n                            }\n                        }\n                    }\n\n                    p {\n                        width: 364px;\n                        color: $dark;\n                        @include mixins.font(FixelText, 16px, normal, 400, 140%);\n\n                        @media (min-width: 1620px) {\n                            width: 434px;\n                            @include mixins.font(FixelText, 20px, normal, 400, 140%);\n                        }\n\n                        @media (max-width: 1050px) {\n                            width: 410px;\n                            @include mixins.font(FixelText, 18px, normal, 400, 140%);\n                        }\n\n                        @media (max-width: 750px) {\n                            display: none;\n                        }\n                    }\n\n                    div {\n                        height: 100%;\n                        @include mixins.flex(column, space-between, flex-start);\n\n                        @media (max-width: 750px) {\n                            width: 100%;\n                            position: relative;\n                            @include mixins.flex(column, flex-start, flex-start);\n                        }\n\n                        span {\n                            width: 200px;\n                            color: $grey-dark;\n                            text-transform: uppercase;\n                            @include mixins.font(FixelDisplay, 24px, normal, 600, 100%);\n\n                            @media (min-width: 1620px) {\n                                width: 258px;\n                                @include mixins.font(FixelDisplay, 32px, normal, 600, 100%);\n                            }\n\n                            @media (max-width: 1050px) {\n                                width: 200px;\n                                @include mixins.font(FixelText, 24px, normal, 600, 100%);\n                            }\n\n                            @media (max-width: 750px) {\n                                width: 100%;\n                                margin-bottom: 24px;\n                            }\n\n                            @media (max-width: 750px) {\n                                @include mixins.font(FixelText, 20px, normal, 600, 120%);\n                            }\n                        }\n\n                        .service-card-info-box-text-mobile {\n                            display: none;\n\n                            @media (max-width: 750px) {\n                                width: 100%;\n                                display: block;\n                                @include mixins.font(FixelText, 14px, normal, 400, 140%);\n                            }\n                        }\n\n                        img {\n                            animation: rotatingStar 8s linear infinite;\n\n                            @media (max-width: 750px) {\n                                visibility: hidden;\n                                position: absolute;\n                                bottom: 0;\n                                left: 0;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n// Stars Rotating Animation\n\n@keyframes rotatingStar {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }","// Colors\n\n$main-color: #982D67;\n$white: #FFFFFF;\n$light-background: #F5F5F5;\n$purple: #812456;\n$grey: #EAEAEA;\n$grey-opacity:#E0E0E0;\n$grey-dark: #575756;\n$grey-text: #BCBCBC;\n$dark: #313130;\n$red: #AE2323;\n$opacity-text: rgba(255, 255, 255, 0.50);","@mixin flex($dir, $jc, $ai) {\n    display: flex;\n    flex-direction: $dir;\n    justify-content: $jc;\n    align-items: $ai;\n}\n\n@mixin font ($font, $size, $style, $weight, $height) {\n    font-family: $font;\n    font-size: $size;\n    font-style: $style;\n    font-weight: $weight;\n    line-height: $height;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
